export function addStripeDataToSubscription(subscription: Subscription, stripeData: StripeData): Subscription {
    Object.assign(subscription.paymentMethod?.creditCard || {}, {
        brand: stripeData.brand,
        lastFourDigits: stripeData.last4,
        expirationMonth: stripeData.exp_month,
        expirationYear: stripeData.exp_year
    });

    return subscription;
}

export default {
    addStripeDataToSubscription
};
